import {Component, OnInit} from '@angular/core';
import {MenuItemType} from '@models/sidebar/menu-item-type';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {MenuItem} from '@models/sidebar/menu-item';
import {BreadcrumbService} from '@services/breadcrumb/breadcrumb.service';
import {utob} from '@prototypes/global.functions';

@Component({
    selector: 'scitis-frame-page-container',
    templateUrl: './frame-page-container.component.html',
    styleUrls: ['./frame-page-container.component.scss'],
    standalone: false
})
export class FramePageContainerComponent implements OnInit {
  public pageType: MenuItemType = MenuItemType.NONE;
  public pageName: string = '';
  public machineId: string = '';
  public pageId: string = '';
  public organizationId: string | null = null;
  public machineCategory: string | null = null;
  public embeddedContendUrl: string | null = null;
  public framePageHelpText: string = '';
  public routes: MenuItem[] = [];

  private associatedMenuItem: MenuItem = new MenuItem();

  constructor(private activatedRoute: ActivatedRoute,
              private translate: TranslateService,
              private breadcrumbService: BreadcrumbService) {
    this.framePageHelpText = this.translate.instant('It is possible that this website does not allow to be embedded. In this case, it cannot be properly displayed.');
  }

  ngOnInit(): void {
    this.getPageDetailsFromURL();
    this.generateRoutes(this.associatedMenuItem);
  }

  private getPageDetailsFromURL(): void {
    const details = this.activatedRoute.snapshot.paramMap.get('details');
    if (!details) {
      return;
    }
    const parsedDetails = JSON.parse(utob(details));

    this.pageName = parsedDetails.name;
    this.pageType = parsedDetails.type as MenuItemType;
    this.machineId = parsedDetails.machine;
    this.organizationId = parsedDetails.organization;
    this.pageId = parsedDetails.pageId;
    this.machineCategory = parsedDetails.machineCategory;
    this.embeddedContendUrl = parsedDetails.url;
    this.associatedMenuItem = parsedDetails.actualMenuItem;
  }

  private generateRoutes(menuItem: MenuItem) {
    this.routes = this.breadcrumbService.generateRoutes(menuItem);
  }

}
